<template>
  <div class="candidate-top-recommendation">
    <!-- if top experience comment, display comment and commentator -->
    <p
v-if="recommendation.getCommentLength() > 0"
       class="candidate-top-recommendation-comment"
       :class="{'extra-comment-quotes': shouldHaveQuotes}"
    >
      <span>{{ formattedComment }}</span>
      <i>{{ qualification }} {{ recommendation.getCommenter() }}</i>
    </p>
    <!-- if no top experience comment, display experience detail -->
    <p
v-if="recommendation.getCommentLength() === 0"
       class="candidate-top-recommendation-no-comment"
    >
      <b>{{ recommendation.getQualificationName() }}</b>
      <br />
      <span>{{ recommendation.getEtabIdentity() }}</span>
      <br />
      <span>{{ recommendation.getDatesDisplay() }} </span>
    </p>
  </div>
</template>

<script>
import { TopRecommendationModel } from "@core/models";

const COMMENT_OVERFLOW_LIMIT = 100;

export default {
  props: {
    recommendation: {
      type: Object,
      default: () => new TopRecommendationModel(),
    },
  },
  computed: {
    formattedComment() {
      const comment = this.recommendation.comment || "";
      if (comment.length > COMMENT_OVERFLOW_LIMIT) {
        return `${comment.substring(0, COMMENT_OVERFLOW_LIMIT)}...`;
      }
      return comment;
    },
    shouldHaveQuotes() {
      return this.recommendation.getCommenter() !== "Extracadabra";
    },
    qualification() {
      const qualification = this.recommendation.getQualificationName();
      if (qualification) {
        return `${qualification}, `;
      }
      return "";
    },
  },
};
</script>

<style lang="scss">
.candidate-top-recommendation {
  height: 120px;
  width: 100%;
  margin: 10px 0;
  padding: 15px;
  color: $primary-medium;
  background-color: $superlightgrey;
  border-radius: 2px;
  position: relative;
  display: flex;
  align-items: center;

  > p {
    width: 100%;
    margin: 0;

    &.candidate-top-recommendation-comment {
      line-height: 1.1em;
      font-style: italic;
      text-align: center;

      i {
        color: $primary-lighter;
        position: absolute;
        bottom: 2px;
        right: 10px;
        width: 80%;
        text-align: right;
        display: inline-block;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }

    &.candidate-top-recommendation-no-comment {
      text-align: left;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;

      span {
        color: $primary-light;
      }
    }
  }
}
</style>
